import React from 'react'
import PedidosYaStyle from '../../../../../assets/css/components/admin/plugins/PedidosYaStyle'

export default function Navbar(props) {
    const {setCurrentStep, currentStep} = props;

    const changeStep = (v) => {
        setCurrentStep(v)
    }
    return (
        <PedidosYaStyle.ContNavbar>
            <PedidosYaStyle.MenuOptions>
                <PedidosYaStyle.OptionMenu active={currentStep === 0} onClick={() => changeStep(0)}>
                    Crear Campaña
                </PedidosYaStyle.OptionMenu>
                <PedidosYaStyle.OptionMenu active={currentStep === 1} onClick={() => changeStep(1)}>
                    Listar Campañas
                </PedidosYaStyle.OptionMenu>
            </PedidosYaStyle.MenuOptions>
        </PedidosYaStyle.ContNavbar>
    )
}
